var map = {
	"./Brides_bw.png": 1047,
	"./Fortune_bw.png": 1048,
	"./MarthaStewartWeddings_bw.png": 1049,
	"./NYT_bw.png": 1050,
	"./VOGUE_bw.png": 1051,
	"./WSJ_bw.png": 1052
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1046;


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/press nonrecursive \.(jpg|jpeg|png|gif|svg)(\?.*)?$
// module id = 1046
// module chunks = 44